import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="insurance-details"
export default class extends Controller {
  static targets = [
    "policyDetailsContainer",
    "policyFormContainer"
  ]

  connect() {
  }

  togglePolicyDetails(event) {
    this.policyDetailsContainerTarget.classList.toggle("hidden")
    this.policyFormContainerTarget.classList.toggle("hidden")
  }
}
